import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { useIntercom } from "react-use-intercom";
import { useMsal } from "@azure/msal-react";
import { connect } from "react-redux";
import { Auth } from "aws-amplify";
import axios from "axios";
import _ from "lodash";

import logo from "assets/images/heylime-logo.png";
import microsoftLogo from "assets/images/pricing/MS-symbol.png";
import facebookLogo from "assets/images/pricing/facebookLogo.png";
import Alert from "components/shared/common/alert";
import onSignIn from "components/shared/utils/onSignIn";
import { loginRequest } from "components/msal/msalConfig";
import { addAudience } from "components/shared/mailchimp";
import * as loaderAction from "redux/loader/action";

const StartFreeTrial = ({ disablePhoneNum, history, ...props }) => {
  const [firstName, setFirstName] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastName, setLastName] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyNameError, setCompanyNameError] = useState("");
  const [agree, setAgree] = useState(false);
  const [showMorebutton, setShowMorebutton] = useState(true);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const gameReducer = _.get(props, "gameReducer");
  const socket_connected = _.get(props, "socketReducer.socketConnection");
  const allParams =
    _.get(gameReducer, "gamesData.onboarding.trial_login") || "";
  const hints = _.get(allParams, "agreement.hints");
  const agreement_text = _.get(allParams, "agreement.text");
  const agreement_links = _.get(allParams, "agreement.links");
  const errors = _.get(allParams, "agreement.errors");
  const { boot, shutdown } = useIntercom();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const { instance } = useMsal();

  console.log("j8dgf382yrhsd");

  const handle_microsoft_login = () => {
    sessionStorage.setItem("trailSocialLogin", true);
    sessionStorage.setItem("disablePhoneNum", disablePhoneNum);
    instance.loginRedirect(loginRequest).catch((e) => {
      console.log(e);
    });
  };

  useEffect(() => {
    boot();

    return () => {
      shutdown();
    };
  }, []);

  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    if (name === "firstName") {
      setFirstName(value);
      setFirstNameError("");
    } else if (name === "lastName") {
      setLastName(value);
      setLastNameError("");
    } else if (name === "email") {
      setEmail(value);
      setEmailError("");
    } else if (name === "password") {
      setPassword(value);
      setPasswordError("");
    } else if (name === "company") {
      setCompanyName(value);
      setCompanyNameError("");
    } else if (name === "phoneNumber") {
      setPhoneNumber(value);
      setPhoneError("");
    }
  };

  const handleAgree = (e) => setAgree(e.target.checked);

  const handleSignIn = () => {
    if (
      firstName !== "" &&
      lastName !== "" &&
      email !== "" &&
      password !== "" &&
      companyName !== "" &&
      agree
    ) {
      props.setIsLoading(true);
      Auth.signUp({
        username: email,
        password: password,
        attributes: {
          email: email,
          name: `${firstName} ${lastName}`
        }
      })
        .then(async (user) => {
          if (user) {
            Alert(200, "You have successfully registered");
            addAudience({
              email: user.user.username
            });
            Auth.signIn(email, password)
              .then(async (user) => {
                if (user) {
                  localStorage.setItem("auth", "login");
                  let url = process.env.REACT_APP_GENERATE_PROMOCODE;
                  const body = {
                    firstName: firstName,
                    lastName: lastName,
                    email: email,
                    businessName: companyName,
                    userId: user.username
                  };
                  if (phoneNumber !== "") {
                    body.phone = phoneNumber;
                  }
                  axios
                    .post(url, body)
                    .then(async (response) => {
                      if (response?.data?.code) {
                        setUserDetails({
                          data: user
                        });
                        props.setIsLoading(false);
                        history.push("/invite_teammates");
                      }
                    })
                    .catch((error) => {
                      props.setIsLoading(false);
                      console.error("Error:", error);
                    });
                }
              })
              .catch((error) => {
                props.setIsLoading(false);
                Alert(400, error.message);
              });
          }
        })
        .catch((error) => {
          props.setIsLoading(false);
          Alert(400, error.message);
        });
    }
  };

  const setUserDetails = async ({ data }) => {
    let payload = data.signInUserSession.idToken.payload;
    await onSignIn(payload);
  };

  useEffect(() => {
    if (socket_connected) {
      props.setIsLoading(false);
    } else {
      props.setIsLoading(true);
    }
  }, [socket_connected]);

  useEffect(() => {
    if (disablePhoneNum) {
      if (
        firstName === "" ||
        lastName === "" ||
        email === "" ||
        password === "" ||
        companyName === "" ||
        !agree
      ) {
        setButtonDisabled(true);
      } else setButtonDisabled(false);
    } else {
      if (
        firstName === "" ||
        lastName === "" ||
        email === "" ||
        password === "" ||
        companyName === "" ||
        phoneNumber === "" ||
        !agree
      ) {
        setButtonDisabled(true);
      } else setButtonDisabled(false);
    }
  }, [firstName, lastName, email, password, companyName, phoneNumber, agree]);

  const check_validation = (field_value) => {
    const email_regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    switch (field_value) {
      case "firstName":
        if (firstName === "") {
          setFirstNameError(errors?.first_name);
        }
        break;
      case "lastName":
        if (lastName === "") {
          setLastNameError(errors?.last_name);
        }
        break;
      case "email":
        if (!email_regex.test(email)) {
          setEmailError(errors?.email);
        }
        break;
      case "password":
        if (password.length < 6) {
          setPasswordError(errors?.password);
        }
        break;
      case "companyName":
        if (companyName === "") {
          setCompanyNameError(errors?.company_name);
        }
        break;
      case "phoneNumber":
        if (phoneNumber === "") {
          setPhoneError("Please enter a valid phone number.");
        }
        break;
      default:
        break;
    }
  };

  return socket_connected ? (
    <div className="trial-login-main">
      <div className="trial-login-header">
        <div className="logo">
          <img
            onClick={() =>
              (window.location.href = "https://www.gameapart.com/")
            }
            src={logo}
            alt="logo"
          />
        </div>
        <div className="trial-contact-us">
          <a href={hints?.contact_link || ""} target="_blank">
            <p>{hints?.contact_text || "Contact Sales"}</p>
          </a>
        </div>
      </div>
      <Container fluid>
        <Row>
          <Col lg={6} xl={6}>
            <div className="trial-login-content">
              <iframe
                title="Trial login webpage"
                src="https://heylime.com/free-trial-sign-up/"
              ></iframe>
            </div>
          </Col>
          <Col lg={5} xl={5}>
            <div className="trail-login-form">
              <h3 className="create-txt">
                {allParams?.create_account || "Create your account"}
              </h3>
              <Row>
                <Col lg={6} xl={6}>
                  <div className={`${firstNameError === "" ? "mb-4" : "mb-2"}`}>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      className="half-input"
                      placeholder={hints?.first_name || "First Name"}
                      value={firstName}
                      onChange={(e) => handleChange(e)}
                      onBlur={() => check_validation("firstName")}
                    />

                    {firstNameError !== "" && (
                      <p className="form_error">{firstNameError}</p>
                    )}
                  </div>
                </Col>
                <Col lg={6} xl={6}>
                  <div className={`${lastNameError === "" ? "mb-4" : "mb-2"}`}>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      className="half-input"
                      placeholder={hints?.last_name || "Last Name"}
                      value={lastName}
                      onChange={(e) => handleChange(e)}
                      onBlur={() => check_validation("lastName")}
                    />
                    {lastNameError !== "" && (
                      <p className="form_error">{lastNameError}</p>
                    )}
                  </div>
                </Col>
                <Col lg={6} xl={6}>
                  <div className={`${emailError === "" ? "mb-4" : "mb-2"}`}>
                    <input
                      type="email"
                      placeholder={hints?.email || "Work Email"}
                      name="email"
                      onChange={(e) => handleChange(e)}
                      value={email}
                      className="half-input"
                      onBlur={() => check_validation("email")}
                    />
                    {emailError !== "" && (
                      <p className="form_error">{emailError}</p>
                    )}
                  </div>
                </Col>
                <Col lg={6} xl={6}>
                  <div className={`${passwordError === "" ? "mb-4" : "mb-2"}`}>
                    <input
                      type="password"
                      id="password"
                      name="password"
                      className="half-input"
                      placeholder={hints?.password || "password"}
                      value={password}
                      onChange={(e) => handleChange(e)}
                      onBlur={() => check_validation("password")}
                    />
                    {passwordError !== "" && (
                      <p className="form_error">{passwordError}</p>
                    )}
                  </div>
                </Col>
                <Col lg={12} xl={12}>
                  <div
                    className={`${companyNameError === "" ? "mb-4" : "mb-2"}`}
                  >
                    <input
                      type="text"
                      id="company"
                      name="company"
                      className="full-input"
                      placeholder={hints?.company_name || "Company Name"}
                      value={companyName}
                      onChange={(e) => handleChange(e)}
                      onBlur={() => check_validation("companyName")}
                    />
                    {companyNameError !== "" && (
                      <p className="form_error">{companyNameError}</p>
                    )}
                  </div>
                </Col>
                {!disablePhoneNum && (
                  <Col lg={12} xl={12}>
                    <div className={`${phoneError === "" ? "mb-4" : "mb-2"}`}>
                      <input
                        type="number"
                        id="phoneNumber"
                        name="phoneNumber"
                        value={phoneNumber}
                        className="full-input"
                        placeholder="Phone Number"
                        onChange={(e) => handleChange(e)}
                        onBlur={() => check_validation("phoneNumber")}
                      />
                      {phoneError !== "" && (
                        <p className="form_error">{phoneError}</p>
                      )}
                    </div>
                  </Col>
                )}
                <div className="trial-sapretor">
                  <p>Or Use Single Sign On</p>
                </div>
                <Col lg={12} xl={12}>
                  <div className="social-login">
                    <div className="form-group">
                      <button
                        className="google-login-btn"
                        name="Google"
                        onClick={() => {
                          sessionStorage.setItem("trailSocialLogin", true);
                          sessionStorage.setItem(
                            "disablePhoneNum",
                            disablePhoneNum
                          );

                          Auth.federatedSignIn({
                            provider: "Google"
                          });
                        }}
                      >
                        <i className="fab fa-google fa-1x"></i>
                        Continue with Google
                      </button>
                    </div>
                    <div className="form-group">
                      <button
                        className="microsoft-login-btn"
                        name="microsoft"
                        onClick={handle_microsoft_login}
                      >
                        <img
                          src={microsoftLogo}
                          className="ms-logo"
                          alt="Microsoft logo"
                        />{" "}
                        Continue with Microsoft
                      </button>
                    </div>
                    {showMorebutton && (
                      <div className="form-group text-center">
                        <button
                          onClick={() => setShowMorebutton(false)}
                          className="show-more-btn"
                        >
                          show more
                        </button>
                      </div>
                    )}
                    {!showMorebutton && (
                      <>
                        <div className="form-group">
                          <button
                            className="apple-login-btn"
                            name="Apple"
                            onClick={() => {
                              sessionStorage.setItem("trailSocialLogin", true);
                              sessionStorage.setItem(
                                "disablePhoneNum",
                                disablePhoneNum
                              );
                              Auth.federatedSignIn({
                                provider: "SignInWithApple"
                              });
                            }}
                          >
                            <i className="fab fa-apple"></i>
                            Continue with Apple
                          </button>
                        </div>
                        <div className="form-group">
                          <button
                            className="facebook-login-btn"
                            name="Facebook"
                            onClick={() => {
                              sessionStorage.setItem("trailSocialLogin", true);
                              sessionStorage.setItem(
                                "disablePhoneNum",
                                disablePhoneNum
                              );
                              Auth.federatedSignIn({
                                provider: "Facebook"
                              });
                            }}
                          >
                            <img
                              src={facebookLogo}
                              className="fb-logo"
                              alt="google logo"
                            />
                            Continue with Facebook
                          </button>
                        </div>
                        <div className="form-group">
                          <button
                            className="amazon-login-btn"
                            name="Amazon"
                            onClick={() => {
                              sessionStorage.setItem("trailSocialLogin", true);
                              sessionStorage.setItem(
                                "disablePhoneNum",
                                disablePhoneNum
                              );
                              Auth.federatedSignIn({
                                provider: "LoginWithAmazon"
                              });
                            }}
                          >
                            <i className="fab fa-amazon"></i>
                            Continue with Amazon
                          </button>
                        </div>
                        <div className="form-group text-center">
                          <button
                            onClick={() => setShowMorebutton(true)}
                            className="show-more-btn"
                          >
                            show less
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="agree">
                    <div>
                      <input
                        type="checkbox"
                        id="agree"
                        name="agree"
                        onChange={(e) => handleAgree(e)}
                        checked={agree}
                      />
                    </div>
                    <p className="agree-txt">
                      {agreement_text[0] || "I agree to the"}{" "}
                      <a
                        href={agreement_links.gameapart_agreement}
                        target="_blank"
                      >
                        {agreement_text[1] || "GameApart Agreement "}
                      </a>{" "}
                      {agreement_text[2] || "and"}
                      <a href={agreement_links.terms} target="_blank">
                        {agreement_text[3] || "Terms"}
                      </a>
                      {agreement_text[4] ||
                        ". Learn about how we use and protect your data in our"}{" "}
                      <a href={agreement_links.privacy_policy} target="_blank">
                        {agreement_text[5] || "Privacy Policy"}
                      </a>
                      .
                    </p>
                  </div>
                  <button
                    disabled={buttonDisabled}
                    className={`start-trial-btn ${
                      buttonDisabled && "btn-disabled"
                    }`}
                    onClick={handleSignIn}
                  >
                    {allParams?.agreement?.trial_button || "Start Free Trial"}
                  </button>
                  <p className="mt-3 text-light text-center">
                    {allParams?.agreement?.credit_card ||
                      "No credit card required"}
                  </p>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  ) : (
    <></>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
  socketReducer: state.socketReducer
});

const mapDispatchToProps = (dispatch) => ({
  setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(StartFreeTrial);
